import React, {Component, Fragment} from 'react';
import UnboxedItem from './UnboxedItem';
import FullBox from './FullBox';
import PartBox from './PartBox';
import classes from './BoxesEditor.css';

export default class BoxesEditor extends Component {
    render() {
        let unboxedItems = this.getUnboxedItems();
        return (
            <Fragment>
                <div className="dialog-content">
                    <div className="dialog-content-indent">
                        <h1 className="custom-m-0 custom-mb-8">Грузовые места</h1>
                        <div>
                            Заказ: #{this.props.yandex_id}
                        </div>
                        {unboxedItems.length > 0 && (
                            <div className="block not-padded top-padded">
                                <h2 className="custom-my-24">Товары без коробки</h2>
                                <table className="zebra">
                                    <thead>
                                    <tr>
                                        <th>Товар</th>
                                        <th>Количество</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {unboxedItems.map((item, i) => (
                                        <UnboxedItem
                                            key={i}
                                            item={item}
                                            boxes={this.state.boxes}
                                            onAddBox={quantity => this.addBoxWithItems([{item: item.item, quantity}])}
                                            onAddToBox={(box, quantity) => this.addItemToBox(box, item.item, quantity)}
                                            onSplit={(quantity, countParts) => this.splitItemToBoxes(item.item, quantity, countParts)}
                                        />
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        <div className="block not-padded top-padded">
                            <h2 className="custom-my-24">Коробки</h2>
                            {this.state.boxes.length ? this.state.boxes.map((box, i) => {
                                if (this.isFullBox(box)) {
                                    return (
                                        <FullBox
                                            key={i}
                                            boxNumber={i + 1}
                                            box={box}
                                            onRemoveItem={(item) => this.removeItemFromBox(box, item)}
                                        />
                                    );
                                } else if (this.isPartialBox(box)) {
                                    return (
                                        <PartBox
                                            key={i}
                                            boxNumber={i + 1}
                                            box={box}
                                            onRemoveItem={(item) => this.removeItemFromBox(box, item)}
                                        />
                                    );
                                } else {
                                    throw new Error('Unknown box type');
                                }
                            }) : (
                                <div>Нет коробок</div>
                            )}
                        </div>
                    </div>
                </div>
                {window.ui_version == 2 ? (
                    <footer className="dialog-footer">
                        <button
                            className={'button ' + (this.state.changed ? 'yellow' : 'green')}
                            onClick={e => {
                                e.preventDefault();
                                this.save();
                            }}
                        >
                            Сохранить
                        </button>
                        <span className="custom-mx-4">или</span>
                            <a
                                href="#"
                            onClick={e => {
                                e.preventDefault();
                                this.close();
                            }}
                        >
                            <span className="custom-mx-4 js-close-dialog">отмена</span>
                        </a>
                        {this.state.loading && (
                            <span><i className="fas fa-spinner wa-animation-spin custom-mr-8" />Загрузка</span>
                        )}
                        {this.state.error && (
                                <span className="errormsg custom-mx-4">{this.state.error}</span>
                        )}
                    </footer>
                ) : (
                    <div className="dialog-buttons">
                        <div className="dialog-buttons-gradient">
                            <ul className={'menu-h ' + classes.controlButtons}>
                                <li>
                                    <button
                                        className={'button ' + (this.state.changed ? 'yellow' : 'green')}
                                        onClick={e => {
                                            e.preventDefault();
                                            this.save();
                                        }}
                                    >
                                        Сохранить
                                    </button>
                                </li>
                                <li>
                                    или
                                </li>
                                <li>
                                    <a
                                        href="#"
                                        onClick={e => {
                                            e.preventDefault();
                                            this.close();
                                        }}
                                    >
                                        отмена
                                    </a>
                                </li>
                                {this.state.loading && (
                                    <li>
                                        <i className="icon16 loading"/>
                                        Загрузка
                                    </li>
                                )}
                                {this.state.error && (
                                    <li>
                                        <span className="errormsg">{this.state.error}</span>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }

    constructor(props) {
        super(props);
        let boxes = props.boxes.map(box => ({
            ...box,
            items: box.items.map(item => {
                let result = {...item};
                delete result.id;
                result.item = this.props.items.find(_item => _item.id === item.id);

                return result;
            })
        }));
        let items = this.props.items.map(item => {
            let sum = boxes.map(box => box.items.map(_item => {
                if (_item.item !== item) {
                    return 0;
                }

                if (this.isFullBox(box)) {
                    return _item.fullCount;
                } else if (this.isPartialBox(box)) {
                    return _item.partialCount.current === 1 ? 1 : 0;
                } else {
                    throw new Error("Unknown box type");
                }
            }).reduce((acc, count) => acc + count, 0)).reduce((acc, count) => acc + count, 0);

            return ({
                item: item,
                quantity: +item.quantity - sum
            });
        });
        this.state = {
            boxes: boxes,
            items: items,
            changed: false,
            loading: false,
            error: null
        };
    }

    componentDidMount() {
        if (this.state.boxes.length === 0 && this.state.items.length !== 0) {
            this.addBoxWithItems(this.state.items);
        }
    }

    getUnboxedItems() {
        return this.state.items.filter(item => item.quantity !== 0);
    }

    addBoxWithItems(items) {
        this.setState((state) => ({
            ...state,
            boxes: [...state.boxes, {
                items: items.map(item => ({
                    item: item.item,
                    fullCount: item.quantity
                }))
            }],
            items: this.state.items.map(_item => {
                let item = items.find(__item => __item.item === _item.item);

                if (!item) {
                    return _item;
                }

                return {
                    ..._item,
                    quantity: _item.quantity - item.quantity
                };
            }),
            changed: true
        }));
    }

    addItemToBox(box, item, quantity) {
        this.setState((state) => ({
            ...state,
            items: state.items.map(_item => _item.item === item ? {
                ..._item,
                quantity: _item.quantity - quantity
            } : _item),
            boxes: state.boxes.map(_box => {
                if (_box !== box) {
                    return _box;
                }

                let foundItem = _box.items.find(_item => _item.item === item);

                if (foundItem) {
                    return {
                        ..._box,
                        items: _box.items.map(_item => _item === foundItem ? ({
                            ..._item,
                            fullCount: _item.fullCount + quantity
                        }) : _item)
                    };
                }

                return {
                    ..._box,
                    items: [..._box.items, {item: item, fullCount: quantity}]
                };
            }),
            changed: true
        }));
    }

    removeItemFromBox(box, item) {
        if (this.isFullBox(box)) {
            this.setState((state) => {
                return {
                    ...state,
                    items: state.items.map(_item => _item.item === item.item ? {
                        ..._item,
                        quantity: _item.quantity + item.fullCount
                    } : _item),
                    boxes: state.boxes.map(_box => _box === box ? ({
                        ..._box,
                        items: _box.items.filter(boxItem => boxItem !== item)
                    }) : _box).filter(_box => _box.items.length > 0),
                    changed: true
                };
            });
        } else if (this.isPartialBox(box)) {
            this.setState((state) => ({
                ...state,
                boxes: state.boxes.map(_box => this.isPartialBox(_box) ? ({
                    ..._box,
                    items: _box.items.filter(_item => _item.groupNumber !== item.groupNumber)
                }) : _box).filter(_box => _box.items.length > 0),
                items: state.items.map(_item => _item.item === item.item ? {
                    ..._item,
                    quantity: _item.quantity + 1
                } : _item),
                changed: true
            }));
        } else {
            throw new Error('Unknown box type');
        }
    }

    splitItemToBoxes(item, quantity, countParts) {
        this.setState((state) => {
            let maxGroupNumber;

            if (state.boxes.length > 0) {
                maxGroupNumber = Math.max.apply(null, state.boxes.map(box => {
                    return Math.max.apply(null, box.items.map(item => item.groupNumber || 0));
                }));
            } else {
                maxGroupNumber = 0;
            }

            let newBoxes = [];

            for (let i = 0; i < quantity; i++) {
                for (let j = 0; j < countParts; j++) {
                    newBoxes.push({
                        items: [{
                            item: item,
                            groupNumber: maxGroupNumber + 1 + i,
                            partialCount: {
                                current: j + 1,
                                total: countParts
                            }
                        }]
                    });
                }
            }

            return {
                ...state,
                boxes: [...state.boxes, ...newBoxes],
                items: state.items.map(_item => _item.item === item ? {
                    ..._item,
                    quantity: _item.quantity - quantity
                } : _item),
                changed: true
            };
        });
    }

    close() {
        let $dialog = null;

        if(window.ui_version == 2) {
            $dialog = $('.dialog');
            $dialog.find('.dialog-body').html('');
        } else {
            $dialog = $('#pokupki-dialog');
            $dialog.find('.dialog-window').html('');
        }

        $dialog.hide();
    }

    save() {
        let boxes = this.state.boxes.map(box => {
            return {
                ...box,
                items: box.items.map(item => {
                    let result = {...item};
                    delete result.item;

                    if (item.item) {
                        result.id = item.item.id;
                    } else {
                        result.id = undefined;
                    }

                    return result;
                })
            };
        });

        this.setState({
            loading: true,
            error: null
        });

        $.ajax({
            method: 'POST',
            url: '?plugin=pokupki&module=api&action=saveBoxes',
            data: {
                request: JSON.stringify({
                    order_id: this.props.order_id,
                    boxes: boxes
                })
            },
            dataType: 'json',
            global: false
        }).done(response => {
            this.setState({
                changed: false,
                loading: false
            });
            this.close();
        }).fail((jqXHR, textStatus, errorThrown) => {
            let message;
            if (jqXHR.responseJSON) {
                message = jqXHR.responseJSON.message;
            } else if (jqXHR.responseText) {
                message = jqXHR.responseText;
            } else {
                message = 'Ошибка';
            }

            this.setState({
                loading: false,
                error: message
            });
        });
    }

    isFullBox(box) {
        return box.items.some(item => item.fullCount);
    }

    isPartialBox(box) {
        return box.items.some(item => item.partialCount);
    }
}